export const ONLY_NUMBERS_REGEX_ONLY_G = /[0-9]/g;
